export { COMUtils } from './src/com-utils.js';
